import * as yup from "yup";

export const signinSchema = (t) => yup.object().shape({
  email: yup.string().required(t("signin.emailRequired")).email(t("signin.emailInvalid")),
  password: yup.string().min(8, t("signin.passwordMin", "Password must be at least 8 characters")).required(t("signin.passwordRequired"))
});
